const key = "ref";

const getRefAndClear = (): string | undefined => {
  try {
    return localStorage.getItem(key) || undefined;
  } catch (e) {
    return undefined;
  } finally {
    localStorage.removeItem(key);
  }
};

const setRef = (ref: string | undefined | null) => {
  if (ref) {
    localStorage.setItem(key, ref);
  }
};

// one object for every render: the functions go in hooks' dependency lists, which must not change each time
const siteRef = { getRefAndClear, setRef };

export const useSiteRef = () => siteRef;
